<div class="body-main" *ngIf="this.userNumber=='0'"> 
  <div class="body-main-top">  
		<section class="container-fluid mt-2 mt-md-3 mb-4">  
			<div class="row">
				<div class="box col-12"> 
					<div class="box-header">
						<div class="box-title">
							<div class="row align-items-center">
								<div class="col"><h3>Users</h3></div>
								<div class="col-auto"> 
								</div>
								<div class="col-auto"><button type="button" class="btn btn-secondary" (click)="backtoSection('users')" >Back to Home</button></div>
							</div>    
						</div> 
					</div> 
					<div class="box-body">
						<div class="row">
							<div class="col-md-8"> 								
								<div *ngIf="rtnStatusData && rtnStatusData.success == true" class="alert alert-success">
									{{ rtnStatusData.message }}
								</div>
								<div class="table-responsive">
									<table class="table table-bordered table-striped table-hover">
										<thead>
											<tr>
											<th>Name</th>
											<th>Email</th>
											<th>Mobile</th>
											<th>Status</th>
											<th>Action</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let udata of userData; let i = index">
											<!--td>#{{i + 1}}</td-->
											<td>{{ udata.UserName }}</td>
											<td>{{ udata.EmailID }}</td>
											<td>{{ udata.Mobile }}</td>
											<td><i  [ngClass]="{'fa d-inline fa-lg' : true, 'fa-user' : udata.status === 'Y', 'fa-user-times' : udata.status === 'N'}" title="Active" (click)="updateStatus(udata._id, udata.status)"></i></td>
											<td> 
											<i *ngIf="(userEditval == 1)?true:false" class="fa d-inline fa-lg fa-edit " (click)="userEdit(udata._id)" ></i> 
											<i *ngIf="(userDelete == 1)?true:false" class="fa d-inline fa-lg fa-trash-o" (click)="deleteUsers(udata._id)"></i>
											</td>
											</tr>              
										</tbody>
									</table>
								</div>
							</div> 
							<div class="col-md-4" *ngIf="(userAdd == 1)?true:false">
								<form (ngSubmit)="onSubmit(userForm, model.id)" #userForm="ngForm">
								<div *ngIf="rtnData && rtnData.success == true" class="alert alert-success">
										{{ rtnData.message }}
									</div>
								<div class="form-group"> <label for="UserName">Display Name</label>
									<input type="text" required class="form-control" id="UserName" placeholder="Enter Display Name" name="UserName" #UserName="ngModel" [(ngModel)]="model.UserName"> 
									<div *ngIf="rtnData && rtnData.message.UserName" class="alert alert-danger">
										{{rtnData.message.UserName}}
									</div>
								</div>
								<div class="form-group"> <label for="EmailID">Email address</label>
								<div>
								<span *ngIf="model.id">{{ model.EmailID }}</span></div>
									<input type="email" class="form-control" id="EmailID" placeholder="Enter email"  
										[(ngModel)]="model.EmailID" name="EmailID" #EmailID="ngModel" *ngIf="!model.id" > 
									<div *ngIf="rtnData && rtnData.message.EmailID && !model.id" class="alert alert-danger">
										{{rtnData.message.EmailID}}
									</div>
								</div> 
								<div class="form-group"> <label for="Password">Password</label>
									<input type="password" class="form-control" id="Password" placeholder="Password"  name="Password" #Password="ngModel" [(ngModel)]="model.Password" > 
									<div *ngIf="rtnData && rtnData.message.Password" class="alert alert-danger">
										{{rtnData.message.Password}}
									</div>
								</div>
								<div class="form-group"> <label for="frmPassword2">Confirm Password</label>
									<input type="password" class="form-control" id="frmPassword2" placeholder="Confirm Password" name="frmPassword2" #frmPassword2="ngModel" [(ngModel)]="model.frmPassword2" > 
									<div *ngIf="rtnData && rtnData.message.frmPassword2" class="alert alert-danger">
										{{rtnData.message.frmPassword2}}
									</div>
								</div>
								<div class="form-group"> <label for="Mobile">Mobile No</label>
									<input type="text" class="form-control" id="Mobile" placeholder="Enter Mobile No" name="Mobile" #Mobile="ngModel" [(ngModel)]="model.Mobile"> 
									<div *ngIf="rtnData && rtnData.message.Mobile" class="alert alert-danger">
										{{rtnData.message.Mobile}}
									</div> 
									</div>
								<div class="form-group"> <label for="UserRole">User Type</label>
									<select class="form-control custom-select" id="UserRole"
										required
										[(ngModel)]="model.UserRole" name="UserRole"
										#UserRole="ngModel">
										<option value="">Select User Type</option>
										<option *ngFor="let usertype of userTypes" [value]="usertype.id">{{usertype.userType}}</option>
									</select>
									<div *ngIf="rtnData && rtnData.message.UserRole" class="alert alert-danger">
										{{rtnData.message.UserRole}}
									</div> 
								</div>
								<div class="form-group"> <label for="status">Status</label> <select class="form-control custom-select" id="status"  [(ngModel)]="model.status" name="status" #status="ngModel">
									<option value="">Select Status</option>
									<option value="Y">Active</option>
									<option value="N">Inactive</option>
									</select> 
									<div *ngIf="rtnData && rtnData.message.status" class="alert alert-danger">
										{{rtnData.message.status}}
									</div>
									</div> 
									<div class="text-right">
										<button type="submit" class="btn btn-primary">{{ (model.id)?"Update":"Create" }}</button>
										<button type="button" (click)="clearFormData()" class="btn btn-secondary">Cancel</button>
									</div>
								</form>
							</div> 
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</div>